var map = {
	"./admins.svg": "WWwQ",
	"./all.svg": "Y8VF",
	"./arcades.svg": "73Ox",
	"./archived.svg": "o/mc",
	"./arrow-down.svg": "3V/M",
	"./arrow-left.svg": "d9Na",
	"./arrow-right.svg": "z5Gb",
	"./arrow-sort-down.svg": "Fzo+",
	"./arrow-sort-up.svg": "zk+I",
	"./arrow-up.svg": "ED5b",
	"./backward.svg": "rgAU",
	"./browser.svg": "ZFNH",
	"./by-reference.svg": "UWKc",
	"./calendar.svg": "3ISY",
	"./challenge.svg": "QqPH",
	"./check-mini.svg": "WtYZ",
	"./check-round.svg": "4ruK",
	"./check.svg": "QETP",
	"./chevron-down.svg": "g69M",
	"./chevron-left.svg": "qFNJ",
	"./chevron-right.svg": "XMvG",
	"./chevron-up.svg": "uQEN",
	"./close-round.svg": "/e7e",
	"./close.svg": "VYr5",
	"./color-match.svg": "kAnv",
	"./columns.svg": "t27V",
	"./connection-quiz.svg": "MYIE",
	"./copy.svg": "O/oa",
	"./courses.svg": "ElFQ",
	"./cross-mini.svg": "0xAW",
	"./cross.svg": "t7ba",
	"./dashboard.svg": "I91k",
	"./difference.svg": "xiW9",
	"./difficulty-easy.svg": "HwgN",
	"./difficulty-hard.svg": "jxUJ",
	"./difficulty-medium.svg": "bIJV",
	"./discord.svg": "UyMN",
	"./divider.svg": "5t0C",
	"./download.svg": "0X/Z",
	"./drafts.svg": "as8p",
	"./drag.svg": "igr3",
	"./edit.svg": "AJRJ",
	"./employees.svg": "e2Qo",
	"./expand.svg": "1AnL",
	"./export.svg": "ztUI",
	"./eye-off.svg": "xfDk",
	"./eye-on.svg": "ADuX",
	"./figma.svg": "tRZw",
	"./file-image.svg": "U6E4",
	"./file-pdf.svg": "YI9d",
	"./file-video.svg": "Bzbm",
	"./filter.svg": "D90i",
	"./folder.svg": "wvRE",
	"./forward.svg": "2960",
	"./fullscreen-exit.svg": "Zvpk",
	"./fullscreen.svg": "CVOq",
	"./game.svg": "tyDr",
	"./hash.svg": "ebun",
	"./heading1.svg": "dBD6",
	"./heading2.svg": "WvL3",
	"./heading3.svg": "g370",
	"./hint.svg": "2kG/",
	"./hints.svg": "rn/O",
	"./history.svg": "9UJ5",
	"./image-text.svg": "iV+V",
	"./image.svg": "pDYf",
	"./import.svg": "km5A",
	"./info.svg": "UGBb",
	"./instagram.svg": "8cRz",
	"./layers.svg": "Ddho",
	"./layers/component.svg": "lmeQ",
	"./layers/ellipse.svg": "ld+g",
	"./layers/exclude.svg": "X23p",
	"./layers/frame.svg": "/gdJ",
	"./layers/group.svg": "RDxa",
	"./layers/image.svg": "kpFr",
	"./layers/instance.svg": "BtuM",
	"./layers/intersect.svg": "a03r",
	"./layers/layout-horizontal-bottom.svg": "ya+z",
	"./layers/layout-horizontal-center.svg": "9lQn",
	"./layers/layout-horizontal-top.svg": "zVz0",
	"./layers/layout-vertical-center.svg": "YXX/",
	"./layers/layout-vertical-left.svg": "bH14",
	"./layers/layout-vertical-right.svg": "6oVR",
	"./layers/layout-wrap-center.svg": "BOCI",
	"./layers/layout-wrap-left.svg": "X5D5",
	"./layers/layout-wrap-right.svg": "4Anc",
	"./layers/line.svg": "M2Wh",
	"./layers/polygon.svg": "HnQi",
	"./layers/rectangle.svg": "1iUo",
	"./layers/star.svg": "LhHu",
	"./layers/subtract.svg": "FGRs",
	"./layers/text.svg": "FPT0",
	"./layers/union.svg": "OCI0",
	"./layers/variant.svg": "hLFa",
	"./layers/vector.svg": "yN8w",
	"./lessons-tree.svg": "T4Ly",
	"./lessons.svg": "LOO4",
	"./linkedin.svg": "ErZ9",
	"./logout.svg": "jy36",
	"./mail.svg": "z3B2",
	"./minus.svg": "FSqS",
	"./modules.svg": "AL78",
	"./more.svg": "QEqt",
	"./number-list.svg": "0G7Y",
	"./open-in-window.svg": "3zSz",
	"./pause.svg": "9zAu",
	"./play-speed.svg": "yl9F",
	"./play.svg": "O83q",
	"./plus-mini.svg": "Yjw3",
	"./plus-round.svg": "wEvt",
	"./plus.svg": "3UYi",
	"./practice.svg": "o7Dd",
	"./properties/arc-start.svg": "8oVo",
	"./properties/auto-height.svg": "Hk+b",
	"./properties/auto-width.svg": "vhI4",
	"./properties/baseline.svg": "V3sX",
	"./properties/blend-mode.svg": "d1gN",
	"./properties/boolean-property.svg": "6QiK",
	"./properties/close-overlay.svg": "QnXg",
	"./properties/constraints-horizontal.svg": "aXcd",
	"./properties/constraints-vertical.svg": "B7yd",
	"./properties/fill-horizontal.svg": "wOvP",
	"./properties/fill-vertical.svg": "pfvt",
	"./properties/fixed-size.svg": "CBUi",
	"./properties/height.svg": "8dBZ",
	"./properties/horizontal-padding.svg": "O0CG",
	"./properties/hug-horizontal.svg": "LWR5",
	"./properties/hug-vertical.svg": "D6Se",
	"./properties/layout-center.svg": "V+rW",
	"./properties/layout-horizontal.svg": "+xFP",
	"./properties/layout-max.svg": "jTA9",
	"./properties/layout-min.svg": "b+N+",
	"./properties/layout-vertical.svg": "wsfx",
	"./properties/layout-wrap.svg": "isdN",
	"./properties/letter-spacing.svg": "gAJe",
	"./properties/line-height.svg": "LVIp",
	"./properties/link.svg": "Z/t+",
	"./properties/lowercase.svg": "4Kr9",
	"./properties/marker-list.svg": "D3IQ",
	"./properties/navigation-back.svg": "X5Lq",
	"./properties/none.svg": "p5ue",
	"./properties/number-list.svg": "HiR5",
	"./properties/open-overlay.svg": "CO6q",
	"./properties/padding-bottom.svg": "CgGL",
	"./properties/padding-left.svg": "8PPq",
	"./properties/padding-right.svg": "2vIa",
	"./properties/padding-top.svg": "Ru4R",
	"./properties/paragraph-spacing.svg": "yTmG",
	"./properties/polygon-point-count.svg": "b7eX",
	"./properties/position-x.svg": "6EWA",
	"./properties/position-y.svg": "V3m7",
	"./properties/radius-bottom-left.svg": "Deh8",
	"./properties/radius-bottom-right.svg": "2eHK",
	"./properties/radius-top-left.svg": "QbZC",
	"./properties/radius-top-right.svg": "FT38",
	"./properties/ratio.svg": "f3EU",
	"./properties/rotation.svg": "cHyi",
	"./properties/scroll-to.svg": "9POU",
	"./properties/shadow-effect.svg": "UeF/",
	"./properties/smallcaps.svg": "sWUs",
	"./properties/spacing-horizontal.svg": "EIMw",
	"./properties/spacing-vertical.svg": "aid5",
	"./properties/star-point-count.svg": "dYNt",
	"./properties/strike-through.svg": "1Xsb",
	"./properties/stroke-all.svg": "0pb3",
	"./properties/stroke-bottom.svg": "g0qS",
	"./properties/stroke-cap-none.svg": "GVOM",
	"./properties/stroke-cap-round.svg": "YvTH",
	"./properties/stroke-cap-square.svg": "L4Ki",
	"./properties/stroke-dash.svg": "cU24",
	"./properties/stroke-join-bevel.svg": "haoq",
	"./properties/stroke-join-miter.svg": "0c5e",
	"./properties/stroke-join-round.svg": "P3Fa",
	"./properties/stroke-left.svg": "vwpk",
	"./properties/stroke-right.svg": "wJ72",
	"./properties/stroke-solid.svg": "+2bE",
	"./properties/stroke-top.svg": "GdYH",
	"./properties/stroke-weight.svg": "juHY",
	"./properties/swap-overlay.svg": "LTKd",
	"./properties/text-align-bottom.svg": "Skdu",
	"./properties/text-align-center.svg": "sxUR",
	"./properties/text-align-justified.svg": "M/Vc",
	"./properties/text-align-left.svg": "zhtj",
	"./properties/text-align-middle.svg": "k9C1",
	"./properties/text-align-right.svg": "gKbW",
	"./properties/text-align-top.svg": "XSzy",
	"./properties/titlecase.svg": "Y2uT",
	"./properties/transition-left.svg": "V7MH",
	"./properties/transition-top.svg": "Q0wQ",
	"./properties/trim-cap-height.svg": "boWh",
	"./properties/trim-standart.svg": "FF1g",
	"./properties/truncate-text.svg": "iRPq",
	"./properties/trunkate.svg": "PlI5",
	"./properties/underline.svg": "73ga",
	"./properties/uppercase.svg": "WWjT",
	"./properties/vertical-padding.svg": "F/Ma",
	"./properties/width.svg": "4Rhw",
	"./properties/x-offset.svg": "7DE5",
	"./properties/y-offset.svg": "xa3m",
	"./published.svg": "z8GK",
	"./question-round.svg": "d+MC",
	"./quiz.svg": "Q2lO",
	"./resync.svg": "RKE7",
	"./round-list.svg": "yqA5",
	"./schools.svg": "f+Z/",
	"./search.svg": "zhpM",
	"./settings.svg": "K2Cn",
	"./sort.svg": "7Opg",
	"./spoiler.svg": "nIXr",
	"./star.svg": "M/HC",
	"./step-by-step.svg": "62py",
	"./stop.svg": "pXrn",
	"./structure.svg": "qqFV",
	"./student.svg": "uncl",
	"./students.svg": "URsg",
	"./text-char.svg": "h9Ht",
	"./text.svg": "v6Q5",
	"./theory.svg": "WzMZ",
	"./tiktok.svg": "6FFs",
	"./trainings.svg": "U4O4",
	"./trash.svg": "uUOr",
	"./two-columns.svg": "agF1",
	"./two-images.svg": "cd9z",
	"./upload.svg": "KH8t",
	"./users.svg": "dSZD",
	"./video-preview.svg": "60kV",
	"./video.svg": "MG4M",
	"./volume-down.svg": "1SwC",
	"./volume-off.svg": "6Pg/",
	"./volume-up.svg": "FfRT",
	"./warning.svg": "5kfs"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ogvf";